var oneSignalId;
$(function(){
    //median.onesignal.run.onesignalInfo();
    if($("#onesignal_id").length > 0){
        $("#onesignal_id").html("Onesignal ID: " + localStorage.getItem('onesignal_id'));
    }
    if(navigator.userAgent.indexOf('iPhone') > -1) {
        if (navigator.userAgent.indexOf('gonative') > -1) {
            $("body").addClass('iphone-sticky');
        }
    }
    if($(".speltips-count").length > 0){
        $.get(
            ajaxUrl + "/ajax/getSpeltipsCount.php",
            function (data) {
                var result = $.parseJSON(data);
                if (result.success == true) {
                    if(result.count > 0) {
                        $(".speltips-count").html(result.count);
                        $(".speltips-count").fadeIn();
                    }
                }
            }
        );
    }
    if($("#fp-hot-fixtures").length > 0){
        $.get(
            ajaxUrl + "/ajax/frontpageHotFixtures.php",
            function (data) {
                var result = $.parseJSON(data);
                if (result.success == true) {
                    $("#fp-hot-fixtures").html(result.data);
                    $('img[data-src]').each(function(img){
                        $(this).attr('src', $(this).data('src'));
                        $(this).removeAttr('data-src');
                    });
                    $(".hot_wrapper").fadeIn();
                }
            }
        );
    }

    if($("#inline_settings_switch").length > 0){
        mySettingsSwitches();
    }

    $(document).on('click', '#disable_app_news', function(){
        $("#app_news_container").hide();
        Cookies.set("app_news_disabled", 1, { expires: 365, path: '/' });
    });

    mySpeltipsCount();

    /*if(Cookies.get("cookie_consent") === undefined){
        $('.cookie_consent_bar').fadeIn();
    }*/

    if($('#fotboll_user_id').length){
        var uid = $('#fotboll_user_id').val();
        Cookies.set("fotboll_com_identifier", uid, { expires: 365, path: '/' });
    }

    if(Cookies.get("fotboll_com_identifier") === undefined){
        if(localStorage.getItem("fotboll_com_identifier") != null){
            guid = localStorage.getItem("fotboll_com_identifier");
        } else {
            guid = (S4() + S4() + "-" + S4() + "-4" + S4().substr(0, 3) + "-" + S4() + "-" + S4() + S4() + S4()).toLowerCase();
        }
        Cookies.set("fotboll_com_identifier", guid, { expires: 3650, path: '/' });
    }

    //Cookies.remove("favourite_teams");
    document.documentElement.addEventListener('gesturestart', function (event) {
        event.preventDefault();
    }, false);

    toggleMySettingsMenu();

    $(document).on("click", ".news-header", function(){
        var href = $(this).data("source");
        //window.open(href,'_blank');
        window.location.replace(href);
    });
    $(document).on("click", "#eighteen_plus_ok", function(){
        Cookies.set('eighteen_plus_ok', 1, { expires: 365, path: '/' });
        $(".responsibility").fadeOut();
        return false;
    });

    $(document).scroll(function() {
        var y = $(this).scrollTop();
        if (y > 1000) {
            $('#backtotop').fadeIn();
        } else {
            $('#backtotop').fadeOut();
        }
    });
    $(document).on("click", ".news-box-mini", function(){
        $(this).find('.load').show();
        setTimeout(function(el){
            $('.load').hide();
        }, 3000);
    });

    /*$(document).on("click", "#cookie_consent_ok", function(){
        Cookies.set('cookie_consent', 1, { expires: 365, path: '/', secure: true });
        $(".cookie_consent_bar").fadeOut();
        return false;
    });*/

    /*$(document).on("click", "#backtotop", function(){
        console.log("bababa");
        $('html,body').animate({
            scrollTop: $("#fotboll-container").offset().top},
        'slow');
        return false;
    });*/

    if($("div[itemtype='https://schema.org/Question']").length > 0){
        var mainEntity = [];
        $("div[itemtype='https://schema.org/Question']").each(function(){
            var item = {
                "@type": "Question",
                "name": $(this).children().find('h3').text(),
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": $(this).children().find('div[itemprop="text"]').text().trim()
                }
            };
            mainEntity.push(item);
        });
        var schemaObj = {
            "@context": "https://schema.org",
            '@type': 'FAQPage',
            'mainEntity': mainEntity
        };

        var script = document.createElement('script');
        script.setAttribute('type', 'application/ld+json');
        var scriptContent = document.createTextNode(JSON.stringify(schemaObj));
        script.appendChild(scriptContent);
        $('body').append(script);
    }

    $(document).on("click", ".add-menu", function(e){
        e.preventDefault();
        if($(".additional-menu").length > 0){
            if($(".my-setting-menu").is(":visible") || $(".search-result-modal").is(":visible")){
                $(".my-setting-menu").hide();
                $(".search-result-modal").hide();
            } else {
                $(".container-main").toggleClass("blur");
                $(".container-vm").toggleClass("blur");
                $(".responsibility").toggleClass("blur");
                $("body").toggleClass("noscroll");
            }
            $(".additional-menu").slideToggle("fast", function(){
                if($(this).is(":visible")){
                    $(".back_button").fadeOut();
                } else {
                    if(!$(".container-fp").length > 0) {
                        $(".back_button").fadeIn("fast");
                    }
                }
            });
            $(this).find(".svg-inline--fa").toggleClass("add-menu-rotated");
        }
        return false;
    });
    $(document).on("click", ".my-settings", function(e){
        e.preventDefault();
        if($(".my-setting-menu").length > 0){
            if($(".additional-menu").is(":visible") || $(".search-result-modal").is(":visible")){
                if($(".additional-menu").is(":visible")){
                    $(".add-menu").find(".svg-inline--fa").toggleClass("add-menu-rotated"); // Here
                    $("#main-nav-icon").toggleClass('open');
                }
                $(".additional-menu").hide();
                $(".search-result-modal").hide();
            } else {
                $(".container-main").toggleClass("blur");
                $(".container-vm").toggleClass("blur");
                $(".responsibility").toggleClass("blur");
                $("body").toggleClass("noscroll");
            }
            $(".my-setting-menu").slideToggle("fast", function(){
                if($(this).is(":visible")){
                    $(".back_button").fadeOut();
                } else {
                    if(!$(".container-fp").length > 0) {
                        $(".back_button").fadeIn("fast");
                    }
                }
            });
        }
        mySettingsSwitches();
        return false;
    });

    $(document).on("click", ".page-search", function(e){
        e.preventDefault();
        var el = $(this);
        if($(".search-result-modal").length > 0){
            if($(".additional-menu").is(":visible") || $(".my-setting-menu").is(":visible")){
                if($(".additional-menu").is(":visible")){
                    $(".add-menu").find(".svg-inline--fa").toggleClass("add-menu-rotated"); // Here
                    $("#main-nav-icon").toggleClass('open');
                }
                $(".additional-menu").hide();
                $(".my-setting-menu").hide();
            } else {
                $(".container-main").toggleClass("blur");
                $(".container-vm").toggleClass("blur");
                $(".responsibility").toggleClass("blur");
                $("body").toggleClass("noscroll");
            }
            $(".search-result-modal").slideToggle("fast", function(){
                if($(this).is(":visible")){
                    $(".modal_search_form").focus();
                    $(".back_button").fadeOut();
                } else {
                    if(!$(".container-fp").length > 0) {
                        $(".back_button").fadeIn("fast");
                    }
                }
            });
        }
        return false;
    });

    $(document).on("click", ".sweden-toggle", function(e){
        e.preventDefault();
        if($(".sweden-picker").length > 0){
            if($(".additional-menu").is(":visible") || $(".my-setting-menu").is(":visible")){
                if($(".additional-menu").is(":visible")){
                    $(".add-menu").find(".svg-inline--fa").toggleClass("add-menu-rotated"); // Here
                    $("#main-nav-icon").toggleClass('open');
                }
                $(".additional-menu").hide();
                $(".my-setting-menu").hide();
            } else {
                $(".container-main").toggleClass("blur");
                $(".container-vm").toggleClass("blur");
                $(".responsibility").toggleClass("blur");
                $("body").toggleClass("noscroll");
            }
            $(".sweden-picker").slideToggle("fast", function(){
                if($(this).is(":visible")){
                    $(".back_button").fadeOut();
                } else {
                    if(!$(".container-fp").length > 0) {
                        $(".back_button").fadeIn("fast");
                    }
                }
            });
        }
        return false;
    });

    $(document).on("click", ".my-settings-close", function(){
        $(".my-setting-menu").slideToggle("fast", function(){
            if($(this).is(":visible")){
                $(".back_button").fadeOut();
            } else {
                if(!$(".container-fp").length > 0) {
                    $(".back_button").fadeIn("fast");
                }
            }
            $(".container-main").toggleClass("blur");
            $(".container-vm").toggleClass("blur");
            $(".responsibility").toggleClass("blur");
            $("body").toggleClass("noscroll");
        });
        return false;
    });

    $("#menu-toppmeny_2 > li.menu-item-type-custom").replaceWith("<div class='menu-divider'></div>");
    $("#menu-toppmeny_2-1 > li.menu-item-type-custom").replaceWith("<div class='menu-divider'></div>");

    $(document).on("click", ".load-more-news", function(){
        var int = $(this).data("international");
        if(int == 1){
            var i = 0;
            $(".hidden-int").each(function(){
                if(i <= 10){
                    $(this).fadeIn();
                    $(this).removeClass("hidden");
                    $(this).removeClass("hidden-int");
                }
                i++;
            });
            if(!$(".hidden-int").length){
                $(this).fadeOut();
            }
        } else {
            var i = 0;
            $(".hidden-swe").each(function(){
                if(i <= 10){
                    $(this).fadeIn();
                    $(this).removeClass("hidden");
                    $(this).removeClass("hidden-swe");
                }
                i++;
            });
            if(!$(".hidden-swe").length){
                $(this).fadeOut();
            }
        }
        return false;
    });

    $(document).on("click", "#finished_load_more", function(){
        var offset = $(this).data("offset");
        $(".finished_tips_list").css("opacity", "0.5");
        $.post(
            ajaxUrl + "/ajax/loadOlderBettingtips.php",
            {
                offset: offset
            },
            function (data) {
                var result = $.parseJSON(data);
                if (result.success == true) {
                    $(".finished_tips_list").append(result.data);
                    $('img[data-src]').each(function(img){
                        $(this).attr('src', $(this).data('src'));
                        $(this).removeAttr('data-src');
                    });
                    $(".finished_tips_list").css("opacity", "1");
                }
            }
        );
        var new_offset = offset + 10;
        $("#finished_load_more").data("offset", new_offset);
        return false;
    });

    $(document).on("click", ".open-invisible", function(){
        var target = $(this).data("target");
        $("#"+target).fadeIn();
        $(this).fadeOut();
        return false;
    });

    $(document).on("click", ".add_favourite_team", function(){
        var team_id = $(this).data("team-id");
        var user_id = Cookies.get("fotboll_com_identifier");

        $.post(
            ajaxUrl + "/ajax/toggleFavouriteTeam.php",
            {
                team_id: team_id,
                subscribed: 1,
                user_id: user_id
            },
            function (data) {
                var result = $.parseJSON(data);
                if (result.success == true) {
                    if(result.data != ""){
                        var cookieString = result.data;
                        Cookies.set('favourite_teams', cookieString, {expires: 365, path: '/'});

                        $.post(
                            ajaxUrl+"/ajax/renderFavouriteTeams.php",
                            function(data){
                                var result = $.parseJSON(data);
                                if(result.success == true){
                                    $(".favourite_teams_wrapper").replaceWith(result.settingHtml);
                                    $(".add-menu-ft .accordion-body").html(result.menuHtml);
                                    $("#team_shortcuts_large").html(result.menuHtml);
                                }
                            }
                        );

                    } else {
                        Cookies.remove('favourite_teams');
                        $(".favourite_teams_wrapper").html('<p class="ft_empty">Du har inte valt något favoritlag</p>').fadeIn();
                    }
                    toggleMySettingsMenu();
                }
            }
        );

        $(".ft_search_form").val("");
        $(".ft_suggestions").html("");
        $(".clear_fav_form").hide();
        $(".search_fav_teams").fadeIn();
    });

    $(document).on("click", ".add_favourite_league", function(){
        var league_id = $(this).data("league-id");
        var user_id = Cookies.get("fotboll_com_identifier");

        $.post(
            ajaxUrl + "/ajax/toggleFavouriteLeague.php",
            {
                league_id: league_id,
                subscribed: 1,
                user_id: user_id
            },
            function (data) {
                var result = $.parseJSON(data);
                if (result.success == true) {
                    if(result.data != ""){
                        var cookieString = result.data;
                        Cookies.set('favourite_leagues', cookieString, {expires: 365, path: '/'});

                        $.post(
                            ajaxUrl+"/ajax/renderFavouriteLeagues.php",
                            function(data){
                                var result = $.parseJSON(data);
                                if(result.success == true){
                                    $(".favourite_leagues_wrapper").replaceWith(result.settingHtml);
                                    $(".add-menu-fl").html(result.menuHtml);
                                    $("#league_shortcuts_large").html(result.menuHtml);
                                }
                            }
                        );

                    } else {
                        Cookies.remove('favourite_leagues');
                        $(".favourite_leagues_wrapper").html('<p class="fl_empty">Du har inte valt någon liga eller cup</p>').fadeIn();
                    }
                    //toggleMySettingsMenu();
                }
            }
        );

        $(".fl_search_form").val("");
        $(".fl_suggestions").html("");
        $(".clear_fav_form").hide();
        $(".search_fav_leagues").fadeIn();
    });

    if($(".app-review-box").length > 0){
        $(".app-review-box .stage").each(function(){
            if($(this).data("stage") == 2){
                $(this).hide();
            }
        });
    }

    if(navigator.userAgent.indexOf('Android') == -1) {
        $(".back_button").addClass("app-visible");
    }

    if(navigator.userAgent.indexOf('iPhone') > -1) {
        if(navigator.userAgent.indexOf('gonative') > -1){
            // Do nothing.
        } else {
            $(".back_button").addClass("iphone-hidden");
        }
    }

    $(document).on("click", ".app-review-box a", function(){
        if($(this).hasClass("app-review-yes")){
            $(".app-review-box .stage_pos").fadeIn();
            if (navigator.userAgent.indexOf('Android') == -1) {
                $(".stage_pos a.app-review-yes").attr("href", "https://itunes.apple.com/app/id1313192702?action=write-review");
            } else {
                $(".stage_pos a.app-review-yes").attr("href", "https://play.google.com/store/apps/details?id=com.fotboll.app");
            }
            return;
        } else {
            $(".app-review-box .stage_neg").fadeIn();
            return;
        }
    });

    $(document).on("click", ".stage_pos a.app-review-yes", function(){
        // Set cookie to not show again for 60 days
        Cookies.set('app_review_jan19', 1, {expires: 365, path: '/'});
        $(".app-review-box").css("height", 0);
        $(".app-review-box").css("margin", 0);
        $(".app-review-box .stage").css("left", -100000);s
        return;
    });
    $(document).on("click", ".stage_neg a.app-review-yes", function(){
        // Set cookie to not show again for 60 days
        Cookies.set('app_review_jan19', 1, {expires: 365, path: '/'});
        $(".app-review-box").css("height", 0);
        $(".app-review-box").css("margin", 0);
        $(".app-review-box .stage").css("left", -100000);
        return;
    });

    $(document).on("click", ".stage_pos a.app-review-no", function(){
        $(".app-review-box").css("height", 0);
        $(".app-review-box").css("margin", 0);
        $(".app-review-box .stage").css("left", -100000);
        // Set cookie to not show again for 60 days
        Cookies.set('app_review_jan19', 1, {expires: 60, path: '/'});
        return;
    });

    $(document).on("click", ".stage_neg a.app-review-no", function(){
        $(".app-review-box").css("height", 0);
        $(".app-review-box").css("margin", 0);
        $(".app-review-box .stage").css("left", -100000);
        // Set cookie to not show again for 60 days
        Cookies.set('app_review_jan19', 1, {expires: 60, path: '/'});
        return;
    });


    $(document).on("click", "button.add_favourite_team", function(){
        $(this).html('<i class="fas fa-check fav-team-activated" data-fa-transform="shrink-10 up-.5" data-fa-mask="fas fa-shield"></i>');
        $(this).removeClass("add_favourite_team").addClass("remove_favourite_team");
    });
    $(document).on("click", "button.remove_favourite_team", function(){
        $(this).html('<i class="fal fa-shield"></i>');
        $(this).removeClass("remove_favourite_team").addClass("add_favourite_team");
        location.reload(1);
    });

    $(document).on("click", ".remove_favourite_team", function(){
        var team_id = $(this).data("team-id");
        //var user_id = localStorage.getItem("fotboll_com_identifier");
        var user_id = Cookies.get("fotboll_com_identifier");

        $.post(
            ajaxUrl + "/ajax/toggleFavouriteTeam.php",
            {
                team_id: team_id,
                subscribed: 0,
                user_id: user_id
            },
            function (data) {
                var result = $.parseJSON(data);
                if (result.success == true) {
                    if(result.data != ""){
                        var cookieString = result.data;
                        Cookies.set('favourite_teams', cookieString, {expires: 365, path: '/'});
                    } else {
                        Cookies.remove('favourite_teams');
                        $(".favourite_teams_wrapper").html('<p class="ft_empty">Du har inte valt något favoritlag</p>').fadeIn();
                    }
                    $(".favourite_teams_wrapper").replaceWith(result.settingHtml);
                    $(".add-menu-ft .accordion-body").html(result.menuHtml);
                }
                toggleMySettingsMenu();
            }
        );
        //$(this).remove();
    });

    $(document).on("click", "button.add_favourite_league", function(){
        $(this).html('<i class="fas fa-check fav-team-activated" data-fa-transform="shrink-10 up-.5" data-fa-mask="fas fa-shield"></i>');
        $(this).removeClass("add_favourite_league").addClass("remove_favourite_league");
    });
    $(document).on("click", "button.remove_favourite_league", function(){
        $(this).html('<i class="fal fa-shield"></i>');
        $(this).removeClass("remove_favourite_league").addClass("add_favourite_league");
        location.reload(1);
    });

    $(document).on("click", ".remove_favourite_league", function(){
        var league_id = $(this).data("league-id");
        //var user_id = localStorage.getItem("fotboll_com_identifier");
        var user_id = Cookies.get("fotboll_com_identifier");

        $.post(
            ajaxUrl + "/ajax/toggleFavouriteLeague.php",
            {
                league_id: league_id,
                subscribed: 0,
                user_id: user_id
            },
            function (data) {
                var result = $.parseJSON(data);
                if (result.success == true) {
                    if(result.data != ""){
                        var cookieString = result.data;
                        Cookies.set('favourite_leagues', cookieString, {expires: 365, path: '/'});
                    } else {
                        Cookies.remove('favourite_leagues');
                        $(".favourite_leagues_wrapper").html('<p class="ft_empty">Du har inte valt några favoritligor</p>').fadeIn();
                    }
                    $(".favourite_leagues_wrapper").replaceWith(result.settingHtml);
                    $(".add-menu-ft .accordion-body").html(result.menuHtml);
                }
                toggleMySettingsMenu();
            }
        );
        //$(this).remove();
    });

    $(document).on("click", ".clear_fav_form", function(){
        $(".ft_search_form").val("");
        $(".ft_suggestions").html("");
        $(this).fadeOut();
    });

    $(".search_fav_teams").click(function(){
        $(this).fadeOut();
        $(".ft_search_form").focus();
        return false;
    });

    $(".search_fav_leagues").click(function(){
        $(this).fadeOut();
        $(".fl_search_form").focus();
        return false;
    });

    $(window).scroll(function(){
        if(!$(".top_menu").hasClass("is_stuck")){
            if($(".badge_logo").hasClass("badge_logo_scrolled")){
                $(".badge_logo").removeClass("badge_logo_scrolled");
            }
        }
        var footer = document.getElementById('footer');
        if(isVisible(footer)){
            if($('#match_menu').is(':visible')) {
                $("#match_menu").fadeOut('fast');
            }
        } else {
            if($('#match_menu').is(':hidden')) {
                $("#match_menu").fadeIn('fast');
            }
        }
    });


    $('body').tooltip({
        selector: '[data-toggle="tooltip"]',
        container : 'body',
        trigger : 'click'
    });

    $(".btn-youtube-speltips").click(function(){
        $(".videoWrapper").slideToggle();
        return false;
    });

    $('body').on('click tochstart', function (e) {
        $('[data-toggle="tooltip"]').each(function () {

//the 'is' for buttons that trigger popups
//the 'has' for icons within a button that triggers a popup
            if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $('.tooltip').has(e.target).length === 0) {
                $(this).tooltip('hide');
            }
        });
    });
    if($("#initiate_ticker").length > 0){
        $('.frontpage-fixtures-ticker').newsTicker({
            row_height: 79,
            max_rows: 4,
            duration: 4000
        });
    }

    [].forEach.call(document.querySelectorAll('img[data-src]'), function(img) {
        img.setAttribute('src', img.getAttribute('data-src'));
        img.onload = function() {
            img.removeAttribute('data-src');
        };
    });
    if (document.referrer.indexOf(window.location.host) !== -1){
        if($(".container-fp").length < 1) {
            if (navigator.userAgent.indexOf('Android') == -1) {
                $('.back_button').fadeIn();
            }
        }
        if($("#android_update").length < 0){
            if (navigator.userAgent.indexOf('Android') == -1) {
                $("#android_update").show();
            }
        }
    }
    $('.js-back').on('click', function(evt) {
        if (document.referrer.indexOf(window.location.host) !== -1){
            window.scrollTo(0,0);
            evt.preventDefault();
            history.back();
        }
    });

    $(".ft_search_form").keyup(function(){

        if($(this).val().length > 1) {
            $(".clear_fav_form").fadeIn();
        } else {
            $(".clear_fav_form").fadeOut();
        }
        if($(this).val().length > 2){
            var search_string = $(this).val();
            $.post(
                ajaxUrl+"/ajax/getTeamsByString.php",
                {
                    search : search_string
                },
                function(data){
                    var result = $.parseJSON(data);
                    if(result.success == true){
                        $(".ft_suggestions").html(result.data);
                    }
                }
            );
        } else {
            $(".ft_suggestions").html("");
            return false;
        }
    });

    $(".fl_search_form").keyup(function(){

        if($(this).val().length > 1) {
            $(".clear_fav_form").fadeIn();
        } else {
            $(".clear_fav_form").fadeOut();
        }
        if($(this).val().length > 1){
            var search_string = $(this).val();
            $.post(
                ajaxUrl+"/ajax/getLeaguesByString.php",
                {
                    search : search_string
                },
                function(data){
                    var result = $.parseJSON(data);
                    if(result.success == true){
                        $(".fl_suggestions").html(result.data);
                    }
                }
            );
        } else {
            $(".fl_suggestions").html("");
            return false;
        }
    });

    $(".modal_search_form").keyup(function(){

        if($(this).val().length > 1){
            var search_string = $(this).val();
            $.post(
                ajaxUrl+"/ajax/getModalSearchResults.php",
                {
                    search : search_string,
                    is_modal : 1
                },
                function(data){
                    var result = $.parseJSON(data);
                    if(result.success == true){
                        $("#modal-search-result").html(result.data);
                    } else {
                        $("#modal-search-result").html(result.message);
                    }
                }
            );
        } else {
            $("#modal-search-result").html("");
            return false;
        }
    });

    $(document).on("click", ".search-extend", function(){
        $("form.modal-page-search").submit();
    });

    $(document).on("click", ".close-menu", function(e){
        e.preventDefault();
        $("#fotboll-container").removeClass('st-menu-open');
        return;
    });

    $(".page_search_form").keyup(function(){

        if($(this).val().length > 1){
            var search_string = $(this).val();
            $.post(
                ajaxUrl+"/ajax/getModalSearchResults.php",
                {
                    search : search_string,
                    is_modal : 0
                },
                function(data){
                    var result = $.parseJSON(data);
                    if(result.success == true){
                        $("#page-search-result").html(result.data);
                    } else {
                        $("#page-search-result").html(result.message);
                    }
                }
            );
        } else {
            $("#page-search-result").html("");
            return false;
        }
    });

    if($("#page_search").length > 0){
        var search = $("#page_search").val();
        if(search != ""){
            $.post(
                ajaxUrl+"/ajax/getModalSearchResults.php",
                {
                    search : search,
                    is_modal : 0
                },
                function(data){
                    var result = $.parseJSON(data);
                    if(result.success == true){
                        $("#page-search-result").html(result.data);
                    } else {
                        $("#page-search-result").html(result.message);
                    }
                }
            );
        } else {
            $("#page-search-result").html("");
        }
    }

    $(document).on("change", ".my_settings_switch", function(e){
        e.preventDefault();
        var type = $(this).data("type");

        var unit_info = oneSignalId; // OneSignal player-id
        if(unit_info == undefined || unit_info == ""){
            unit_info = localStorage.getItem('onesignal_id');
            if(unit_info == undefined || unit_info == ""){
                unit_info == Cookies.get('player_id');
                if(unit_info == undefined || unit_info == "") {
                    unit_info = "";
                }
            }
        }
        //alert(unit_info);

        if($(this).is(":checked")){
            var checked = 1;
        } else {
            var checked = 0;
        }

        // If favourite team(s) shortcut enabled
        if(type == "favourite-teams-shortcut"){
            if(checked){
                Cookies.set("add_ft_shortcuts", 1, { expires: 365, path: '/' });
                var teams = Cookies.get("favourite_teams");

                $.post(
                    ajaxUrl+"/ajax/addTeamsInMenu.php",
                    {
                        teams : teams
                    },
                    function(data){
                        var result = $.parseJSON(data);
                        if(result.success == true){
                            $(".add-menu-ft .accordion-body").html(result.data);
                            $("#team_shortcuts_large").html(result.data);
                        }
                    }
                );

            } else {
                $(".add-menu-ft .accordion-body").html("");
                $("#team_shortcuts_large").html("");
                Cookies.remove("add_ft_shortcuts");
            }

            $.post(
                ajaxUrl+"/ajax/toggleMySettings.php",
                {
                    setting : "my_team_shortcuts",
                    value   : checked,
                    //user_id : localStorage.getItem("fotboll_com_identifier"),
                    user_id : Cookies.get("fotboll_com_identifier"),
                    player_id : unit_info
                },
                function(data){
                    var result = $.parseJSON(data);
                    if(result.success != true){
                        console.log(result.msg);
                    }
                }
            );
        }

        // Favourite teams pushnotifications toggle - App only
        if(type == "favourite-teams-push"){
            if (navigator.userAgent.indexOf('gonative') > -1 || navigator.userAgent.indexOf('median') > -1) {
                if (checked) {
                    // Set cookie
                    Cookies.set("ft_push_notifications", 1, {expires: 365, path: '/'});
                    $(".my-match-notices").fadeIn();
                } else {
                    // Remove cookie
                    Cookies.remove("ft_push_notifications");
                    $(".my-match-notices").removeClass("my-match-notices-visible").fadeOut();
                }

                $.post(
                    ajaxUrl + "/ajax/toggleMySettings.php",
                    {
                        setting : "my_teams_notifications",
                        value : checked,
                        //user_id : localStorage.getItem("fotboll_com_identifier"),
                        user_id : Cookies.get("fotboll_com_identifier"),
                        player_id: unit_info
                    },
                    function (data) {
                        var result = $.parseJSON(data);
                        if (result.success != true) {
                            console.log(result.msg);
                        }
                    }
                );
            } else {
                return false;
            }
        }

        // My fixtures pushnotifications toggle - App only
        if(type == "my-fixtures-push"){

            if (checked) {
                // Set cookie
                Cookies.set("mf_push_notifications", 1, {expires: 365, path: '/'});
                Cookies.set("ft_push_notifications", 1, {expires: 365, path: '/'});
                $(".my-match-notices").fadeIn();
            } else {
                // Remove cookie
                Cookies.remove("mf_push_notifications");
                Cookies.remove("ft_push_notifications");
                $(".my-match-notices").removeClass("my-match-notices-visible").fadeOut();
            }

            $.post(
                ajaxUrl + "/ajax/toggleMySettings.php",
                {
                    setting : "my_fixtures_notifications",
                    value : checked,
                    user_id : Cookies.get("fotboll_com_identifier"),
                    player_id: unit_info
                },
                function (data) {
                    var result = $.parseJSON(data);
                    if (result.success != true) {
                        alert("Någonting gick fel. Försök igen om en liten stund");
                    }
                }
            );
            // Set my teams notifications to the same
            $.post(
                ajaxUrl + "/ajax/toggleMySettings.php",
                {
                    setting : "my_teams_notifications",
                    value : checked,
                    user_id : Cookies.get("fotboll_com_identifier"),
                    player_id: unit_info
                },
                function (data) {
                    var result = $.parseJSON(data);
                    if (result.success != true) {
                        alert("Någonting gick fel. Försök igen om en liten stund");
                    }
                }
            );
        }

        // Settings for fixtures push notifications - App only
        if(type == "fixture-push-settings"){
            if (navigator.userAgent.indexOf('gonative') > -1 || navigator.userAgent.indexOf('median') > -1) {
                // User want to exclude certain events from push notifications
                var field = $(this).data("field");

                if(field == "corners"){
                    var cookieString = "push_include_" + field;
                    if (!$(this).is(":checked")) {
                        // Set cookie
                        Cookies.set(cookieString, 1, {expires: 365, path: '/'});
                        var inactivate = 0;
                    } else {
                        // Remove cookie
                        Cookies.remove(cookieString);
                        var inactivate = 1;
                    }
                } else {
                    var cookieString = "push_exclude_" + field;
                    if (!$(this).is(":checked")) {
                        // Set cookie
                        Cookies.set(cookieString, 1, {expires: 365, path: '/'});
                        var inactivate = 1;
                    } else {
                        // Remove cookie
                        Cookies.remove(cookieString);
                        var inactivate = 0;
                    }
                }

                $.post(
                    ajaxUrl + "/ajax/updateMyNotificationsSettings.php",
                    {
                        unit_info: unit_info,
                        field : $(this).data("field"),
                        inactivate : inactivate
                    },
                    function (data) {
                        var result = $.parseJSON(data);
                        if (result.success != true) {
                            console.log(result.msg);
                        }
                    }
                );
            } else {
                return false;
            }
        }

        // Speltips pushnotifications toggle - App only
        if(type == "speltips-push"){

            if (checked) {
                // Set cookie
                Cookies.set("speltips_push_notifications", 1, {expires: 365, path: '/'});
            } else {
                // Remove cookie
                Cookies.remove("speltips_push_notifications");
            }

            $.post(
                ajaxUrl + "/ajax/toggleMySettings.php",
                {
                    setting : "speltips_notifications",
                    value : checked,
                    user_id : Cookies.get("fotboll_com_identifier"),
                    player_id: unit_info
                },
                function (data) {
                    var result = $.parseJSON(data);
                    if (result.success != true) {
                        alert("Någonting gick fel. Försök igen om en liten stund");
                    }
                }
            );
        }

        if(type == "accepts_mail"){
            $.post(
                ajaxUrl + "/ajax/toggleMySettings.php",
                {
                    setting : "accepts_mail",
                    value : checked,
                    user_id : Cookies.get("fotboll_com_identifier"),
                    player_id: unit_info
                },
                function (data) {
                    var result = $.parseJSON(data);
                    if (result.success != true) {
                        alert("Någonting gick fel. Försök igen om en liten stund");
                    }
                }
            );
        }

    });

    if($("#cc-btn-lg").length > 0) {
        document.getElementById('cc-btn-lg').onclick = function () {
            FB.ui({
                method: 'share',
                display: 'popup',
                href: 'https://www.fotboll.com/tävling',
                quote: 'Jag tävlar om en fotbollsresa på Fotboll.com'
            }, function (response) {
                $(".btn-submit-cc").removeClass("not-shared");
            });
        }
    }
    if($("#cc-btn-xs").length > 0) {
        document.getElementById('cc-btn-xs').onclick = function () {
            FB.ui({
                method: 'share',
                mobile_iframe: true,
                href: 'https://www.fotboll.com/tävling',
                quote: 'Jag tävlar om en fotbollsresa på Fotboll.com'
            }, function (response) {
                $(".btn-submit-cc").removeClass("not-shared");
            });
        }
    }

    if (navigator.userAgent.indexOf('gonative') == -1) {
        new SmartBanner({
            daysHidden: 15,   // days to hide banner after close button is clicked (defaults to 15)
            daysReminder: 90, // days to hide banner after "VIEW" button is clicked (defaults to 90)
            appStoreLanguage: 'se', // language code for the App Store (defaults to user's browser language)
            title: 'Fotboll.com',
            author: 'Fotboll.com',
            button: 'VISA',
            store: {
                ios: 'I App Store',
                android: 'I Google Play'
            },
            price: {
                ios: 'Gratis',
                android: 'Gratis'
            },
            // , theme: '' // put platform type ('ios', 'android', etc.) here to force single theme on all device
            icon: '/launcher-icon-4x.png' // full path to icon image if not using website icon image
            // , force: 'ios' // Uncomment for platform emulation
        });
    }

    if($("#fotboll_id").length > 0){
        //$("#fotboll_id").html("Fotboll ID: " + Cookies.get("fotboll_com_identifier"));
    }

    $('img[data-src]').each(function(img){
        $(this).attr('src', $(this).data('src'));
        $(this).removeAttr('data-src');
    });

    $(document).on("click", ".transfer_player_anchor", function(){
        var target = $(this).data("target");
        $(".transfer_wrapper > ul > li").removeClass("tr_data_active");
        $(".tr_data_wrapper").slideUp();
        $(".tr_data_wrapper[data-div-id='" + target + "']").slideToggle();
        $(".tr_data_wrapper[data-div-id='" + target + "']").parent().addClass("tr_data_active");
    });

    $(document).on("change", "#blog_leagues", function(){
        var league = $(this).val();
        var blogaction = "category";
        $.get(
            ajaxUrl + "/ajax/blogFilter.php",
            {
                blogaction : blogaction,
                category : league
            },
            function (data) {
                var result = $.parseJSON(data);
                if (result.success == true) {
                    $("#blog_posts").html(result.data);
                }
            }
        );
    });

    $(document).on("click", ".report-error-btn", function(){
        var url = $(this).data("url");
        $(".back_button").fadeOut();
        $.post(
            ajaxUrl+"/ajax/renderErrorPopup.php",
            {
                url : url
            },
            function(data){
                var result = $.parseJSON(data);
                if(result.success == true){
                    BootstrapDialog.show({
                        title: 'Rapportera ett fel',
                        message: result.data,
                        nl2br: false,
                        cssClass: 'modal-error-body',
                        onhidden: function(){
                            $(".back_button").fadeIn();
                        }
                    });
                }
            }
        );
    });

    $(document).on("click", ".btn-submit-error", function(){
        var name = $("#error-name").val();
        var email = $("#error-email").val();
        var url = $("#error-url").val();
        var message = $("#error-message").val();

        $.post(
            ajaxUrl+"/ajax/insertReportedError.php",
            {
                name : name,
                email : email,
                url : url,
                message : message
            },
            function(data){
                var result = $.parseJSON(data);
                if(result.success == true){
                    $("#error-save").fadeIn();
                    setTimeout(function(){
                        BootstrapDialog.closeAll();
                    }, 2000);
                }
            }
        );
        return false;
    });

    $(document).on("click", ".preview-full-article", function(){
        window.location = $(this).data('href');
        return;
        if($(this).hasClass("article-preview")){
            return;
        }
        var article_loaded = $(this).data("article-loaded");
        var el = $(this);
        if(article_loaded == 0){
            // Scroll to top
            var id = $(this).data("article-id");
            el.find(".article").addClass("article-loading");
            $.post(
                ajaxUrl+"/ajax/getNewsArticle.php",
                {
                    article_id : id
                },
                function(data){
                    var result = $.parseJSON(data);
                    if(result.success == true){
                        // Populate div and data
                        $("div[data-article-content-id='" + id + "']").html(result.data);

                        if(result.tags != ""){
                            $("div[data-article-tags-id='" + id + "']").html(result.tags);
                        }

                        // Set article data to loaded
                        el.data("article-loaded", 1);

                        // Toggle class and show news
                        el.toggleClass("article-preview");
                        el.find(".article").removeClass("article-loading");

                        // Hide scyscrapers
                        $("#lg-box-scyscraper").toggleClass("d-lg-block");
                    }
                }

            );
        } else {
            $(this).toggleClass("article-preview");
            $("#lg-box-scyscraper").toggleClass("d-lg-block");
        }
        //return false;
    });

    $(document).on("click", ".article-close", function(){
        $(this).closest(".preview-full-article").removeClass("article-preview");
        $("#lg-box-scyscraper").toggleClass("d-lg-block");
        return false;
    });

    $(document).on("click", "#render-more-news a", function(){
        var limit = $(this).data("limit");
        var run = $(this).data("run");
        var catId = $(this).data("cat-id");
        var offset = run * limit;
        $.post(
            ajaxUrl+"/ajax/getNewsArticles.php",
            {
                offset : offset,
                limit  : limit,
                catId  : catId
            },
            function(data){
                var result = $.parseJSON(data);
                if(result.success == true){
                    // Populate div and data
                    $("#news-wrapper").append(result.data);
                } else {
                   $("#render-more-news").fadeOut();
                }
            }

        );
        run += 1;
        $(this).data("run", run);
        return false;
    });

    $(document).on("click", ".copy-url", function(){
        $(this).find("span").text("Kopierat!");
        var el = $(this);
        setTimeout(function(){
            el.find("span").text("Kopiera URL");
        }, 1000)
        Clipboard_CopyTo($(this).data("href"));
        return false;
    });

    $(document).on('click', '#mark_speltips_as_read', function(){
        var notifications = $(this).data('notification-id');
        $.post(
            ajaxUrl+"/ajax/markNotificationsAsRead.php",
            {
                notifications  : notifications
            },
            function(data){
                var result = $.parseJSON(data);
                if(result.success == true){
                    // Populate div and data
                    $("#my_notifications").fadeOut();
                    $(".my-speltips-count").removeClass('my-matches-count-show');
                }
            }

        );
    });

    /*$(document).on("click", "body", function(e){
        if(e.target != $(".preview-full-article")){
            console.log("si body");
            $(".preview-full-article").removeClass("article-preview");
        }
    });*/


});
// When the user clicks on the button, scroll to the top of the document
function topFunction() {
    document.body.scrollTop = 0; // For Chrome, Safari and Opera
    document.documentElement.scrollTop = 0; // For IE and Firefox
}

function gonative_onesignal_info(oneSignalInfo) {
    oneSignalId = oneSignalInfo.oneSignalUserId;

}
function median_onesignal_infoz(oneSignalInfo) {
    oneSignalId = oneSignalInfo;
    if($("#onesignal_id").length > 0){
        $("#onesignal_id").html("Onesignal ID: " + oneSignalId);
    }
}

function mySettingsSwitches() {
    $(".my_settings_switch").each(function (c, item) {
        if($(this).attr("data-switchery") != "true") {
            new Switchery(item, {size: 'large'});
        }
    });
}

function toggleMySettingsMenu(){
    var teams = Cookies.get("favourite_teams");
    if(teams != undefined){
        $(".table-my-settings td").css("opacity","1");
        $(".my_settings_switch").prop("disabled",false);
    } else {
        $(".table-my-settings td").css("opacity",".5");
        $(".my_settings_switch").prop("disabled",false);
    }
}

function S4() {
    return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
}

function validateEmail(email){
    var re = /\S+@\S+\.\S+/;
    return re.test(email);
}
function Clipboard_CopyTo(value) {
    var tempInput = document.createElement("input");
    tempInput.value = value;
    document.body.appendChild(tempInput);
    tempInput.select();
    document.execCommand("copy");
    document.body.removeChild(tempInput);
}

function mySpeltipsCount(){
    $.get(
        ajaxUrl + "/ajax/my_speltips_fixtures_count.php?time=" + Date.now(),
        function (data) {
            var result = $.parseJSON(data);
            if (result.success == true) {
                if(result.count > 0) {
                    $(".my-speltips-count").html(result.count)
                    $(".my-speltips-count").addClass('my-matches-count-show');
                }
            }
        }
    );
}

function isVisible (ele) {
    const { top, bottom } = ele.getBoundingClientRect();
    const vHeight = (window.innerHeight || document.documentElement.clientHeight);

    return (
        (top > 0 || bottom > 0) &&
        top < vHeight
    );
}
